import { render, staticRenderFns } from "./DonationDropBox.vue?vue&type=template&id=64de2edc&scoped=true"
import script from "./DonationDropBox.vue?vue&type=script&lang=js"
export * from "./DonationDropBox.vue?vue&type=script&lang=js"
import style0 from "./DonationDropBox.vue?vue&type=style&index=0&id=64de2edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64de2edc",
  null
  
)

export default component.exports